import { Col, Form, Input, InputNumber, Radio, Row, Select } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { InitialData } from '../../common/InitialData';
import { ErrorMessage, Field, Formik } from 'formik';
import { Employment_Type, Finance_Type } from '../../common/Constants';
import { RequiredFields } from '../../common/RequiredFields';
import {
  convertObject,
  hasKeysAndNotEmpty,
  reverseObject,
} from '../../common/Utilities';
import { useSelector } from 'react-redux';

const EmploymentDetails = ({
  type,
  guarantor_index,
  updateFunction,
  productData,
}) => {
  const [employementDetails, setEmployemntDetails] = useState(
    InitialData.applicant_employement_details
  );
  const guarantorDetails = useSelector((state) => state.guarantorInfo.guarantorDetails);
  const guarantorButtonId = useSelector((state) => state.guarantorInfo.guarantorButtonId);
  const [applicantTypeLabel, setApplicantTypeLable] = useState('');
  const [validationDetails, setValidationDetails] = useState({});
  const matchedGuarantor = guarantorDetails.find((item) => item.guarantorButtonId === guarantorButtonId);

  const getMinimumIncome = matchedGuarantor ? matchedGuarantor.minIncome : null;

  console.log("Matched Min Income:", getMinimumIncome);

  const handleBlur = (e, formikProps) => {
    const { name, value } = e.target;
    let updateData =
      Object.keys(validationDetails).length === 0
        ? convertObject(formikProps.values)
        : { ...validationDetails };
    if (!updateData[name]) {
      updateData[name] = { validation: false, value: "" };
    }
    updateData[name].validation = value !== "";
    updateData[name].value = value;
    [
      "employer_previous_occupation",
      "employer_previous_name",
      "employer_previous_experience_years",
      "employer_previous_experience_months",
      "employer_previous_address",
      "employer_previous_postal_code",
    ].forEach((field) => {
      if (!updateData[field]) updateData[field] = { validation: true, value: "" };
      updateData[field].validation = true;
    });
    formikProps.setFieldValue(name, value);
    formikProps.setFieldTouched(name, true);
    setEmployemntDetails(formikProps.values);
    setValidationDetails(updateData);

    if (type === "applicant") {
      localStorage.setItem(
        "applicant_employement_details",
        JSON.stringify(updateData)
      );
    } else {
      localStorage.setItem(
        "guarantor_employement_details_" + guarantor_index,
        JSON.stringify(updateData)
      );
    }
  };


  const handleDropdownChange = (name, value, formikProps) => {
    let data = { ...employementDetails };
    formikProps.setFieldValue(name, value);
    formikProps.setFieldTouched(name, true);
    data[name] = value;
    let updateData =
      Object.keys(validationDetails).length == 0
        ? convertObject(data)
        : validationDetails;
    if (!updateData[name]) {
      updateData[name] = { validation: false, value: "" };
    }
    updateData[name].validation = value !== "";
    updateData[name]['value'] = value;
    setEmployemntDetails(data);
    if (name == 'employment_type' && value == 'Unemployed') {
      for (const key in updateData) {
        if (key !== 'employment_type') {
          updateData[key]['validation'] = true;
          updateData[key]['value'] = '';
        }
      }
    }
    setValidationDetails(updateData);
    if (type == 'applicant') {
      localStorage.setItem(
        'applicant_employement_details',
        JSON.stringify(updateData)
      );
    } else {
      localStorage.setItem(
        'guarantor_employement_details_' + guarantor_index,
        JSON.stringify(updateData)
      );
    }
  };

  useEffect(() => {
    let savedValues = {};
    if (type == 'applicant') {
      savedValues = localStorage.getItem('applicant_employement_details');
    } else {
      savedValues = localStorage.getItem(
        'guarantor_employement_details_' + guarantor_index
      );
    }
    if (savedValues && Object.keys(savedValues).length != 0) {
      let parsedValues = JSON.parse(savedValues);
      setValidationDetails(parsedValues);
      parsedValues = reverseObject(parsedValues);
      setEmployemntDetails(parsedValues);
    }
    let applicantTypeValue = localStorage.getItem('applicanttype');
    if (applicantTypeValue) {
      setApplicantTypeLable(applicantTypeValue);
    }
  }, []);

  useEffect(() => {
    let validationemployment = false;
    let validationPersonal = false;
    let applicantDetails = localStorage.getItem('applicant_details');
    if (type == 'applicant' && applicantDetails) {
      if (employementDetails) {
        validationemployment = hasKeysAndNotEmpty(
          employementDetails,
          RequiredFields.applicant_employement_details
        );
      }
      if (applicantDetails) {
        validationPersonal = hasKeysAndNotEmpty(
          JSON.parse(applicantDetails),
          RequiredFields.applicant_details
        );
      }
      if (applicantTypeLabel == 'Company') {
        if (validationPersonal == true) {
          updateFunction('step3', 'completed', true);
          updateFunction('step3', 'viewed', true);
        }
      } else {
        if (validationemployment == true && validationPersonal == true) {
          updateFunction('step3', 'completed', true);
          updateFunction('step3', 'viewed', true);
        }
      }
    } else {
      let guarantorDetails = localStorage.getItem(
        'guarantor_personal_details_' + guarantor_index
      );
      if (employementDetails) {
        validationemployment = hasKeysAndNotEmpty(
          employementDetails,
          RequiredFields.applicant_employement_details
        );
      }
      if (guarantorDetails) {
        validationPersonal = hasKeysAndNotEmpty(
          JSON.parse(guarantorDetails),
          RequiredFields.applicant_details
        );
      }
    }
  }, [employementDetails]);
  return (
    <div>
      <Formik enableReinitialize={true} initialValues={employementDetails}>
        {(formikProps, setFieldValue, values) => (
          <Form>
            <div className='input-one-line-dealer'>
              <div className='input-group w-full md:w-[230px]'>
                <label>Employment</label>
                <Form.Item className='mt-1 w-full'>
                  <Field name='employment_type'>
                    {({ field }) => (
                      <Select
                        {...field}
                        name='employment_type'
                        onChange={(e) => {
                          handleDropdownChange(
                            'employment_type',
                            e,
                            formikProps
                          );
                        }}
                        options={Employment_Type}
                        value={employementDetails.employment_type}
                      />
                    )}
                  </Field>
                  {validationDetails?.employment_type?.validation == false && (
                    <span className='error'>Employment Required</span>
                  )}
                </Form.Item>
              </div>
              <div className='input-group w-full md:w-[230px]'>
                <label>Occupation</label>
                <Form.Item className='mt-1'>
                  <Field name='occupation'>
                    {({ field }) => (
                      <Input
                        disabled={
                          formikProps.values.employment_type == 'Unemployed'
                            ? true
                            : false
                        }
                        {...field}
                        onBlur={(e) => handleBlur(e, formikProps)}
                        value={
                          formikProps.values.employment_type == 'Unemployed'
                            ? ''
                            : field.value
                        }
                      />
                    )}
                  </Field>
                  {validationDetails?.occupation?.validation == false &&
                    formikProps.values.employment_type != 'Unemployed' && (
                      <span className='error'>Occupation Required</span>
                    )}
                </Form.Item>
              </div>
              <div className='input-group w-full md:w-[230px]'>
                <label>Type of Industry</label>
                <Form.Item name='field2' className='mt-1'>
                  <Field name='type_of_industry'>
                    {({ field }) => (
                      <Input
                        disabled={
                          formikProps.values.employment_type == 'Unemployed'
                            ? true
                            : false
                        }
                        {...field}
                        onBlur={(e) => handleBlur(e, formikProps)}
                      />
                    )}
                  </Field>
                  {validationDetails?.type_of_industry?.validation == false &&
                    formikProps.values.employment_type != 'Unemployed' && (
                      <span className='error'>Industry Type Required</span>
                    )}
                </Form.Item>
              </div>
            </div>
            <div className='input-one-line-dealer'>
              <div className='input-group w-full md:w-[230px]'>
                <label>Length of service</label>
                <div className='flex items-start'>
                  <div className='input-group w-[100px] mr-2 !mb-0'>
                    <div className='flex'>
                      <Field name='service_duration_years'>
                        {({ field }) => (
                          <Input
                            disabled={
                              formikProps.values.employment_type == 'Unemployed'
                                ? true
                                : false
                            }
                            className='p-[5px_6px]'
                            {...field}
                            onBlur={(e) => handleBlur(e, formikProps)}
                          />
                        )}
                      </Field>
                      <label className='mt-2 ml-2 whitespace-nowrap'>
                        Year(s)
                      </label>
                    </div>
                    {validationDetails?.service_duration_years?.validation ==
                      false &&
                      formikProps.values.employment_type != 'Unemployed' && (
                        <span className='error'>Required</span>
                      )}
                  </div>
                  <div className='input-group w-[112px] !mb-0'>
                    <div className='flex'>
                      <Field name='service_duration_months'>
                        {({ field }) => (
                          <Input
                            disabled={
                              formikProps.values.employment_type == 'Unemployed'
                                ? true
                                : false
                            }
                            className='p-[5px_6px]'
                            {...field}
                            onBlur={(e) => handleBlur(e, formikProps)}
                          />
                        )}
                      </Field>
                      <label className='mt-2 ml-2 whitespace-nowrap'>
                        Month(s)
                      </label>
                    </div>
                    {validationDetails?.service_duration_months?.validation ==
                      false &&
                      formikProps.values.employment_type != 'Unemployed' && (
                        <span className='error'>Required</span>
                      )}
                  </div>
                </div>
              </div>
              <div className='input-group w-full md:w-[230px]'>
                <label>Monthly Income</label>
                <Form.Item name='field2' className='mt-1'>
                  <Field name='monthly_income'>
                    {({ field, form }) => (
                      <Input
                        disabled={formikProps.values.employment_type === 'Unemployed'}
                        {...field}
                        onBlur={(e) => {
                          const { value } = e.target;
                          if (!value || value === '') {
                            setValidationDetails((prev) => ({
                              ...prev,
                              monthly_income: {
                                ...prev.monthly_income,
                                validation: false,
                                errorMessage: 'Monthly Income is required',
                                value: value,
                              },
                            }));
                          } else if (parseFloat(value) < parseFloat(getMinimumIncome)) {
                            setValidationDetails((prev) => ({
                              ...prev,
                              monthly_income: {
                                ...prev.monthly_income,
                                validation: false,
                                errorMessage: `Monthly Income must be at least $${parseInt(getMinimumIncome)}`,
                                value: value,
                              },
                            }));
                          } else {
                            setValidationDetails((prev) => ({
                              ...prev,
                              monthly_income: {
                                ...prev.monthly_income,
                                validation: true,
                                errorMessage: '',
                                value: value,
                              },
                            }));
                          }

                          // Update Formik field value
                          form.setFieldValue('monthly_income', value);
                          form.setFieldTouched('monthly_income', true);
                        }}
                      />
                    )}
                  </Field>
                  {validationDetails?.monthly_income?.validation === false &&
                    formikProps.values.employment_type !== 'Unemployed' && (
                      <span className='error'>
                        {validationDetails?.monthly_income?.errorMessage}
                      </span>
                    )}
                </Form.Item>
              </div>

              <div className='input-group w-full md:w-[230px]'>
                <label>Other Income</label>
                <Form.Item name='field2' className='mt-1'>
                  <Field name='other_income'>
                    {({ field }) => (
                      <Input
                        disabled={
                          formikProps.values.employment_type == 'Unemployed'
                            ? true
                            : false
                        }
                        {...field}
                        onBlur={(e) => handleBlur(e, formikProps)}
                      />
                    )}
                  </Field>
                  {validationDetails?.other_income?.validation == false &&
                    formikProps.values.employment_type != 'Unemployed' && (
                      <span className='error'>Other Income Required</span>
                    )}
                </Form.Item>
              </div>
              <div className='input-group w-full md:w-[230px]'>
                <label>Finance Type</label>
                <Form.Item className='mt-1 w-full'>
                  <Field name='finance_type'>
                    {({ field }) => (
                      <Select
                        disabled={
                          formikProps.values.employment_type == 'Unemployed'
                            ? true
                            : false
                        }
                        {...field}
                        name='finance_type'
                        onChange={(e) => {
                          handleDropdownChange('finance_type', e, formikProps);
                        }}
                        options={Finance_Type}
                        value={employementDetails.finance_type}
                      />
                    )}
                  </Field>
                  {validationDetails?.finance_type?.validation == false &&
                    formikProps.values.employment_type != 'Unemployed' && (
                      <span className='error'>Finance Type Required</span>
                    )}
                </Form.Item>
              </div>
            </div>
            <div className='input-one-line-dealer'>
              <div className='input-group w-full md:w-[230px]'>
                <label>Employer Name</label>
                <Form.Item name='field2' className='mt-1'>
                  <Field name='employer_name'>
                    {({ field }) => (
                      <Input
                        disabled={
                          formikProps.values.employment_type == 'Unemployed'
                            ? true
                            : false
                        }
                        {...field}
                        onBlur={(e) => handleBlur(e, formikProps)}
                      />
                    )}
                  </Field>
                  {validationDetails?.employer_name?.validation == false &&
                    formikProps.values.employment_type != 'Unemployed' && (
                      <span className='error'>Employer Name Required</span>
                    )}
                </Form.Item>
              </div>
              <div className='input-group w-full md:w-[230px]'>
                <label>Employer Address</label>
                <Form.Item name='field2' className='mt-1'>
                  <Field name='employer_address'>
                    {({ field }) => (
                      <Input
                        disabled={
                          formikProps.values.employment_type == 'Unemployed'
                            ? true
                            : false
                        }
                        {...field}
                        onBlur={(e) => handleBlur(e, formikProps)}
                      />
                    )}
                  </Field>
                  {validationDetails?.employer_address?.validation == false &&
                    formikProps.values.employment_type != 'Unemployed' && (
                      <span className='error'>Employer Address Required</span>
                    )}
                </Form.Item>
              </div>
              <div className='input-group w-full md:w-[230px]'>
                <label>Postal Code</label>
                <Form.Item name='field2' className='mt-1'>
                  <Field name='employer_postal_code'>
                    {({ field }) => (
                      <Input
                        disabled={
                          formikProps.values.employment_type == 'Unemployed'
                            ? true
                            : false
                        }
                        maxLength={6}
                        {...field}
                        onBlur={(e) => handleBlur(e, formikProps)}
                      />
                    )}
                  </Field>
                  {validationDetails?.employer_postal_code?.validation ==
                    false &&
                    formikProps.values.employment_type != 'Unemployed' && (
                      <span className='error'>Postal Code Required</span>
                    )}
                </Form.Item>
              </div>
            </div>
            <div className='input-one-line-dealer'>
              <div className='input-group w-full md:w-[230px]'>
                <label>Previous occupation (If any)</label>
                <Form.Item name='field2' className='mt-1'>
                  <Field name='employer_previous_occupation'>
                    {({ field }) => (
                      <Input
                        disabled={
                          formikProps.values.employment_type == 'Unemployed'
                            ? true
                            : false
                        }
                        {...field}
                        onBlur={(e) => handleBlur(e, formikProps)}
                      />
                    )}
                  </Field>
                </Form.Item>
              </div>
              <div className='input-group w-full md:w-[230px]'>
                <label>Previous Employer Name</label>
                <Form.Item name='field2' className='mt-1'>
                  <Field name='employer_previous_name'>
                    {({ field }) => (
                      <Input
                        disabled={
                          formikProps.values.employment_type == 'Unemployed'
                            ? true
                            : false
                        }
                        {...field}
                        onBlur={(e) => handleBlur(e, formikProps)}
                      />
                    )}
                  </Field>
                </Form.Item>
              </div>
              <div className='input-group w-full md:w-[230px] mb-0'>
                <label>Length of service</label>
                <div className='flex gap-x-2 items-start'>
                  <div className='flex'>
                    <Field name='employer_previous_experience_years'>
                      {({ field }) => (
                        <Input
                          disabled={
                            formikProps.values.employment_type == 'Unemployed'
                              ? true
                              : false
                          }
                          className='p-[5px_6px]'
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    <label className='mt-2 ml-1 whitespace-nowrap'>
                      Year(s)
                    </label>
                  </div>
                  <div className='flex'>
                    <Field name='employer_previous_experience_months'>
                      {({ field }) => (
                        <Input
                          disabled={
                            formikProps.values.employment_type == 'Unemployed'
                              ? true
                              : false
                          }
                          className='p-[5px_6px]'
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    <label className='mt-2 ml-1 whitespace-nowrap'>
                      Month(s)
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className='input-one-line-dealer'>
              <div className='input-group w-full md:w-[230px]'>
                <label>Previous Employer Address</label>
                <Form.Item name='field2' className='mt-1'>
                  <Field name='employer_previous_address'>
                    {({ field }) => (
                      <Input
                        disabled={
                          formikProps.values.employment_type == 'Unemployed'
                            ? true
                            : false
                        }
                        {...field}
                        onBlur={(e) => handleBlur(e, formikProps)}
                      />
                    )}
                  </Field>
                </Form.Item>
              </div>
              <div className='input-group w-full md:w-[230px]'>
                <label>Postal Code</label>
                <Form.Item name='field2' className='mt-1'>
                  <Field name='employer_previous_postal_code'>
                    {({ field }) => (
                      <Input
                        disabled={
                          formikProps.values.employment_type == 'Unemployed'
                            ? true
                            : false
                        }
                        {...field}
                        onBlur={(e) => handleBlur(e, formikProps)}
                        maxLength={6}
                      />
                    )}
                  </Field>
                </Form.Item>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default EmploymentDetails;
